// AUTO-GENERATED SQL Builder (V40 Final) for PaymentEvent
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class PaymentEventSql {
  private ast = new SqlAst('PaymentEvent', 'paymentEvent');
  public readonly main: any = {};

  public guid: SqlField;
  public paymentId: SqlField;
  public bookingId: SqlField;
  public source: SqlField;
  public eventType: SqlField;
  public gatewayEventId: SqlField;
  public signatureValid: SqlField;
  public payloadJson: SqlField;
  public status: SqlField;
  public processedDate: SqlField;
  public payment: SqlNavHybrid;
  public booking: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('paymentEvent', 'guid', '', 'id', 'paymentEvent_guid');
    this.paymentId = new SqlField('paymentEvent', 'paymentId', 'payment', 'id', 'paymentEvent_payment');
    this.bookingId = new SqlField('paymentEvent', 'bookingId', 'booking', 'id', 'paymentEvent_booking');
    this.source = new SqlField('paymentEvent', 'source', '', 'id', 'paymentEvent_source');
    this.eventType = new SqlField('paymentEvent', 'eventType', '', 'id', 'paymentEvent_eventType');
    this.gatewayEventId = new SqlField('paymentEvent', 'gatewayEventId', '', 'id', 'paymentEvent_gatewayEvent');
    this.signatureValid = new SqlField('paymentEvent', 'signatureValid', '', 'id', 'paymentEvent_signatureValid');
    this.payloadJson = new SqlField('paymentEvent', 'payloadJson', '', 'id', 'paymentEvent_payloadJson');
    this.status = new SqlField('paymentEvent', 'status', '', 'id', 'paymentEvent_status');
    this.processedDate = new SqlField('paymentEvent', 'processedDate', '', 'id', 'paymentEvent_processedDate');
    this.payment = createNavHybrid('paymentEvent', 'paymentEvent_payment', 'Payment');
    this.booking = createNavHybrid('paymentEvent', 'paymentEvent_booking', 'Booking');
    this.createdByUser = createNavHybrid('paymentEvent', 'paymentEvent_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('paymentEvent', 'paymentEvent_updatedByUser', 'User');
    this.id = new SqlField('paymentEvent', 'id', '', 'id', 'paymentEvent_id');
    this.isDeleted = new SqlField('paymentEvent', 'isDeleted', '', 'id', 'paymentEvent_isDeleted');
    this.createdBy = new SqlField('paymentEvent', 'createdBy', '', 'id', 'paymentEvent_createdBy');
    this.createdDate = new SqlField('paymentEvent', 'createdDate', '', 'id', 'paymentEvent_createdDate');
    this.updatedBy = new SqlField('paymentEvent', 'updatedBy', '', 'id', 'paymentEvent_updatedBy');
    this.updatedDate = new SqlField('paymentEvent', 'updatedDate', '', 'id', 'paymentEvent_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:PaymentEventSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:PaymentEventSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:PaymentEventSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:PaymentEventSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:PaymentEventSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:PaymentEventSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:PaymentEventSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:PaymentEventSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:PaymentEventSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:PaymentEventSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
